import React from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import logo from '../wysupp-icon-green-transparent.svg';
import AccountInfo from '../AccountInfo';
import { FaPlusCircle, FaEdit, FaArrowLeft } from 'react-icons/fa';

export default function ManageProjects() {
    const navigate = useNavigate();

    return (
        <div className="admin-page-container">
            <header className="dashboard-header">
                <Link to="/home" style={{ textDecoration: 'none' }}>
                    <div className="logo-section" style={{ cursor: 'pointer' }}>
                        <img src={logo} className="logo-icon" alt="Wysupp Logo" />
                        <span className="logo-text">Wysupp Validate</span>
                        <span className="logo-subtext">Data Quality Management</span>
                    </div>
                </Link>
                <AccountInfo />
            </header>

            <main className="admin-main-content">
                <div className="page-header">
                    <button onClick={() => navigate('/home')} className="back-button">
                        <FaArrowLeft /> Back
                    </button>
                    <h1 className="page-title">Manage Projects</h1>
                </div>
                <p className="page-subtitle">Select an action to configure project settings, interfaces, and user assignments.</p>

                <div className="nav-cards-grid">
                    {/* Create Project Card */}
                    <div className="nav-card">
                        <div className="card-icon-wrapper">
                            <FaPlusCircle />
                        </div>
                        <h3 className="card-title">Create Project</h3>
                        <p className="card-description">Set up a new project, define its scope, activate the necessary interfaces, and assign users.</p>
                        <div className="card-buttons">
                            <button onClick={() => navigate('/admin/manage-projects/create-project')} className="card-button primary">
                                Create New Project
                            </button>
                        </div>
                    </div>

                    {/* Edit Project Card */}
                    <div className="nav-card">
                        <div className="card-icon-wrapper">
                            <FaEdit />
                        </div>
                        <h3 className="card-title">Edit Project</h3>
                        <p className="card-description">Modify project details, update active interfaces, change user assignments, or adjust delivery schedules.</p>
                        <div className="card-buttons">
                            <button onClick={() => navigate('/admin/manage-projects/edit-project')} className="card-button primary">
                                Edit Project
                            </button>
                        </div>
                    </div>
                </div>
            </main>
            <style>{`
                body {
                    background-color: var(--dark-bg);
                }
                :root {
                    --dark-bg: #1a202c;
                    --card-bg: #2d3748;
                    --text-color: #e2e8f0;
                    --light-text: #a0aec0;
                    --green-accent: #48bb78;
                    --border-color: #4a5568;
                }

                .admin-page-container {
                    background-color: var(--dark-bg);
                    min-height: 100vh;
                    color: var(--text-color);
                    font-family: 'Inter', sans-serif;
                }

                .dashboard-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 1rem 3rem;
                    background-color: var(--card-bg);
                    border-bottom: 1px solid var(--border-color);
                }
                .logo-section { display: flex; align-items: center; gap: 0.5rem; }
                .logo-icon { width: 30px; height: 30px; }
                .logo-text { font-size: 1.25rem; font-weight: 700; color: var(--green-accent); }

                .admin-main-content {
                    max-width: 1200px;
                    margin: 2rem auto;
                    padding: 2rem;
                }

                .page-header {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 1rem;
                }
                .back-button {
                    background: var(--card-bg); color: var(--text-color); border: 1px solid var(--border-color);
                    padding: 0.5rem 1rem; border-radius: 6px; font-weight: 600; cursor: pointer;
                    transition: background-color 0.2s; display: flex; align-items: center; gap: 0.5rem;
                }
                .back-button:hover { background: #4a5568; }
                .page-title { font-size: 2rem; font-weight: 700; color: var(--text-color); }
                .page-subtitle { font-size: 1rem; color: var(--light-text); margin-bottom: 3rem; max-width: 1000px; }

                .nav-cards-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
                    gap: 2rem;
                }

                .nav-card {
                    background-color: var(--card-bg);
                    border-radius: 12px;
                    padding: 2.5rem;
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    text-align: left;
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    border: 1px solid var(--border-color);
                }

                .nav-card:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 30px rgba(0,0,0,0.2);
                }

                .card-icon-wrapper {
                    font-size: 2.5rem;
                    color: var(--green-accent);
                    background-color: rgba(72,187,120,0.1);
                    padding: 1rem;
                    border-radius: 50%;
                    margin-bottom: 1.5rem;
                    display: inline-flex;
                }

                .card-title {
                    font-size: 1.5rem;
                    font-weight: 700;
                    color: var(--text-color);
                    margin-bottom: 1rem;
                }

                .card-description {
                    font-size: 0.95rem;
                    color: var(--light-text);
                    line-height: 1.6;
                    margin-bottom: 2rem;
                    flex-grow: 1;
                }

                .card-buttons {
                    margin-top: auto;
                    width: 100%;
                }

                .card-button {
                    padding: 0.8rem 1.5rem;
                    border: none;
                    border-radius: 6px;
                    font-size: 1rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s ease;
                    width: 100%;
                }

                .card-button.primary {
                    background-color: var(--green-accent);
                    color: var(--dark-bg);
                }
                .card-button.primary:hover {
                    background-color: #38a169;
                }
                .logo-subtext {
                    font-size: 0.75rem;
                    color: var(--light-text);
                    margin-left: 0.5rem;
                    padding-left: 0.5rem;
                    border-left: 1px solid var(--light-text);
                }
            `}</style>
        </div>
    );
}